import { Text, Input } from "@chakra-ui/react";
import { AccountPermission } from "@syla/shared/types/models/AccountAccessBase";
import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import { hasAccountPermission } from "../../../helper/permissions";
import { useReportError } from "../../../helpers/useReportError";
import { useMutationUpdateAccount } from "../../../store/useMutationUpdateAccount";
import { Account } from "../../../types/Account";
import {
  EditableFieldProps,
  EditableField,
} from "../../molecules/EditableField";

export function AccountAbnEditable({
  account,
  ...props
}: { account: Account } & Partial<EditableFieldProps>) {
  const { mutateAsync: updateAccount } = useMutationUpdateAccount(account._id);
  const [updateInProgress, setUpdateInProgress] = useState(false);
  const reportError = useReportError();

  const canChangeAccountDetails = hasAccountPermission(
    account,
    AccountPermission.ChangeAccountDetails,
  );

  const { watch, register, formState, resetField } = useFormContext<{
    abn: string;
  }>();
  return (
    <EditableField
      displayElement={<Text>{watch("abn")}</Text>}
      editElement={<Input autoFocus {...register("abn")} />}
      isDirty={formState.dirtyFields.abn}
      isLoading={updateInProgress}
      onSave={async () => {
        try {
          setUpdateInProgress(true);
          await updateAccount({
            abn: watch("abn"),
          });
        } finally {
          setUpdateInProgress(false);
        }
      }}
      onCancel={() => resetField("abn")}
      onError={reportError}
      canEdit={canChangeAccountDetails}
      {...props}
    />
  );
}
